import { Grid, Paper } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import PlanHeader from "../../../../shared/enrollment/planCode/PlanHeader";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import EditIcon from "@mui/icons-material/Edit";
import { Suspense, useCallback, useContext } from "react";
import { ThemeContext } from "../../../../../contexts";
import { AcknowledgementProps } from "../../../../../types/components/enrollmentProps.types";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import PanToolIcon from "@mui/icons-material/PanTool";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ClearIcon from "@mui/icons-material/Clear";
import "./enrollmentAcknowledgement.css";
import { Status } from "../../../../../types/enrollment.types";
import downloadFile from "../../../../../utils/commonFunctions/downloadFile";
import downloadFileNew from "../../../../../utils/commonFunctions/downloadFileNew";
import { LazyPlanBranding } from "../../../../shared";
import {
	BOPPanhandleFirstBankDentalPlanBrandingLogo,
	BOPPanhandleFirstBankHealthPlanBrandingLogo,
	BOPPanhandleFirstBankLogo,
	BOPPanhandleFirstBankVisionPlanBrandingLogo
} from "../../../../../assets";

type StatusIcon = {
	[key in Status]: JSX.Element;
};

type StatusMessage = {
	[key in Status]: string;
};

const statusIcon: StatusIcon = {
	ACTIVE: <DoneAllIcon className="thank-icon" />,
	SUBMITTED: <DoneOutlineIcon className="thank-icon" />,
	REJECTED: <ClearIcon className="thank-icon" />,
	WAIVED: <PanToolIcon className="thank-icon" />,
	"WAIVED - WAITING FOR APPROVAL": <WatchLaterIcon className="thank-icon" />,
	OPENED: <></>,
	CLOSED: <></>
};

const statusMessage: StatusMessage = {
	ACTIVE: "Your enrollment is successfully Activated",
	SUBMITTED: "Your enrollment has been successfully Submitted",
	REJECTED: "Your enrollment has been Rejected",
	WAIVED: "Your enrollment is successfully waived",
	"WAIVED - WAITING FOR APPROVAL": "Your enrollment for waived is pending for approval",
	OPENED: "",
	CLOSED: ""
};

const PFBEnrollmentAcknowledgement = ({
	idCardAccessPointRequired,
	dependentChangePointRequired,
	carrierPhoneNo,
	carrierWebsite,
	planDocument,
	planName,
	addDependentLink,
	removeDependentLink,
	planCode,
	status,
	customStatusMeesage
}: AcknowledgementProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	// console.log("status", status);
	const handleDownloadPlanDocument = useCallback(() => {
		if (!planDocument) {
			alert("No plan document is available");
			return;
		} else downloadFileNew(planDocument);
	}, [planDocument]);

	return (
		<div className="enrollment-acknowledgement">
			<PlanHeader planCode={planCode} planName={planName} />

			<div className="theme-plan-section-margin" />
			<div className="theme-plan-section-margin" />
			<div className="bop-bfp-logo-container">
				<img src={BOPPanhandleFirstBankLogo} />
			</div>
			{!["OPENED", "CLOSED"].includes(status) ? (
				<>
					<Grid container direction="column" alignItems="center">
						{statusIcon[status as keyof StatusIcon]}
					</Grid>
					<div className="thank-note">
						{customStatusMeesage && status === "SUBMITTED"
							? customStatusMeesage
							: statusMessage[status as keyof StatusMessage]}
					</div>
				</>
			) : null}
		</div>
	);
};

export default PFBEnrollmentAcknowledgement;
